import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const container = css`
  position: relative;
  display: inline-block;
  vertical-align: middle;

  &:hover .dropdown,
  .dropdown:hover {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
    z-index: 1;
  }
`

export const hidden = css`
  display: none;
`

export const link = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${theme.palette.additionalColor.purple[700]};

  span {
    font-weight: 500;
  }

  ${breakpoint.up('smMd')} {
    display: inline;
    position: relative;
    padding: 15px 0;

    span {
      display: inline;
    }
  }
`

export const inverted = (theme: Theme) => css`
  ${breakpoint.up('smMd')} {
    color: ${theme.palette.background.primary};
  }
`

export const full = (theme: Theme) => css`
  ${breakpoint.up('smMd')} {
    padding-bottom: ${size[40]};
    margin-bottom: ${size[20]};

    &:hover::before {
      content: '';
      height: 3px;
      background: ${theme.palette.brand[500]};
      width: ${size[90]};
      display: block;
      position: absolute;
      border-radius: 0 0 6px 6px;
      z-index: 10;
      bottom: 5px;
      left: 0;
    }
  }
`

export const icon = () => css`
  fill: #828b99;

  ${breakpoint.up('smMd')} {
    min-width: ${size[12]};
    margin: 0 0 0 ${size[8]};
    fill: currentColor;
  }
`
